import * as React from "react";
import ReactTable from "react-table";
import { FiltroAdminServicios, Servicio } from "../modelo/AdminServicio";
import { OverlayTrigger, Tooltip, Glyphicon } from "react-bootstrap";
import ModalAdminServicios from "./ModalAdminServicios";


export default class TablaAdminParametros extends React.Component<TablaAdminParametrosProps, any> {

    columns = [{
        id: "servicioMinisterio",
        Header: "Cod Min",
        accessor: "servicioMinisterio",
        Cell: props => (this.renderTexto(props)),
        width: 70
    },{
        id: "nombreServicio",
        Header: "Nombre",
        accessor: "nombreServicio",
        Cell: props => (this.renderTexto(props)),
        width: 175
    }, {
        id: "consecutivo",
        Header: "Cod Sura",
        accessor: "consecutivo",
        Cell: props => (this.renderTexto(props)),
        width: 75
    }, {
        id: "textoSelector",
        Header: "Selector",
        accessor: "textoSelector",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "snGestionable",
        Header: "Gestionable",
        accessor: "snGestionable",
        Cell: props => (this.renderBoolean(props)),
        width: 75
    }, {
        id: "snEnvioSat",
        Header: "Envio SAT",
        accessor: "snEnvioSat",
        Cell: props => (this.renderBoolean(props)),
        width: 75
    }, {
        id: "snReciboSat",
        Header: "Recibo SAT",
        accessor: "snReciboSat",
        Cell: props => (this.renderBoolean(props)),
        width: 75
    }, {
        id: "snEncriptarEnvioSat",
        Header: "Encriptar",
        accessor: "snEncriptarEnvioSat",
        Cell: props => (this.renderBoolean(props)),
        width: 75
    }, {
        id: "snEncriptarReciboSat",
        Header: "DesEncriptar",
        accessor: "snEncriptarReciboSat",
        Cell: props => (this.renderBoolean(props)),
        width: 75
    }, {
        id: "intentos",
        Header: "Intentos",
        accessor: "intentos",
        Cell: props => (this.renderTexto(props)),
        width: 70
    }, {
        id: "tiempoIntento",
        Header: "Tiempo Intento",
        accessor: "tiempoIntento",
        Cell: props => (this.renderTexto(props)),
        width: 85
    }, {
        id: "dniIngreso",
        Header: "Usuario Ingreso",
        accessor: "dniIngreso",
        Cell: props => (this.renderTexto(props)),
        width: 90
    }, {
        id: "consecutivo",
        Header: "Accion",
        accessor: "consecutivo",
        Cell: props => (this.renderAccion(props)),
        width: 60
    }
    ];

    renderAccion = (props: any) => {
        if (props.original.pendiente) {
            return (
                <button type="button" className="btns btns-glyphicon">
                    <span className="icons-table">
                        <Glyphicon glyph={"transfer"} />
                    </span>
                </button>
            );
        } else {
            return (
                <ModalAdminServicios
                    consecutivo={props.original.consecutivo}
                    nombreServicio={props.original.nombreServicio}
                    descripcion={props.original.descripcion}
                    urlServicio={props.original.urlServicio}
                    tablaTraza={props.original.tablaTraza}
                    snEnvioSat={props.original.snEnvioSat}
                    snReciboSat={props.original.snReciboSat}
                    snEncriptarEnvioSat={props.original.snEncriptarEnvioSat}
                    snEncriptarReciboSat={props.original.snEncriptarReciboSat}
                    fechaAlta={props.original.fechaAlta}
                    fechaBaja={props.original.fechaBaja}
                    fechaIngresa={props.original.fechaIngresa}
                    intentos={props.original.intentos}
                    tiempoIntento={props.original.tiempoIntento}
                    servicioMinisterio={props.original.servicioMinisterio}
                    dniIngreso={props.original.dniIngreso}
                    snGestionable={props.original.snGestionable}
                    textoSelector={props.original.textoSelector}
                    servicioDependientes={props.original.servicioDependientes}
                    idCliente={props.original.idCliente}
                />
            );
        }
    }

    render() {
        const { servicios, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (servicios.length < tamanoPagina) {
            numRegistros = servicios.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{servicios.length}</span> Parámetros encontrados
                    </h2>
                </div>
                <ReactTable data={servicios}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroAdminServicios = {
            consecutivo: this.props.filtro.consecutivo,
            palabraClave: this.props.filtro.palabraClave,
            claveSN: this.props.filtro.claveSN,
            valorSN: this.props.filtro.valorSN,
            tipoFecha: this.props.filtro.tipoFecha,
            fecha: this.props.filtro.fecha,
            complementoFecha: this.props.filtro.complementoFecha,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderTexto = (props: any) => {
        if (props.value || !isNaN(props.value)) {
            if (props.value.length > 20) {
                const tooltip = (
                    <Tooltip id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{props.value}</Tooltip>
                );
                return (
                    <div style={{ marginTop: '10px' }}>
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <span>{props.value}</span>
                        </OverlayTrigger>
                    </div>
                );
            }
            return (
                <div style={{ marginTop: '10px' }}>
                    <span>{props.value}</span>
                </div>
            );
        }
        return (props.value);
    }

    renderBoolean = (props: any) => {
        const snBloqueante = props.value ? "SI" : "NO";
        return (
            <div style={{ marginTop: '10px' }}>
                <span>{snBloqueante}</span>
            </div>
        );
    }
}

interface TablaAdminParametrosProps {
    servicios: Array<Servicio>
    filtro: FiltroAdminServicios,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtro: FiltroAdminServicios) => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/componentes/TablaAdminServicios.tsx